import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as UnCheckedBoxIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import type { FC } from "react";

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
}

const ShowHistoricalCheckbox: FC<Props> = ({ value, onChange }) => {
  return (
    <Tooltip title="Pokaż historyczne zamówienia">
      <IconButton color="inherit" onClick={() => onChange(!value)}>
        {value ? <CheckBoxIcon /> : <UnCheckedBoxIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ShowHistoricalCheckbox;
